import classNames from 'classnames';
import { FC, useEffect, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { baseUrl } from '@/src/assets/utils/baseUrl';

import { FacebookIcon } from '../../icons/facebookIcon/FacebookIcon';
import { LinkIcon } from '../../icons/linkIcon/LinkIcon';
import { RedditIcon } from '../../icons/redditIcon/RedditIcon';
import { TwitterIcon } from '../../icons/twitterIcon/TwitterIcon';

import styles from './BlogPostShareBlock.module.scss';

interface ShareBlockProps {
    postSlug: string;
    className?: string;
}

const ShareBlock: FC<ShareBlockProps> = ({ postSlug, className }) => {
    const [isCopied, setIsCopied] = useState<boolean>(false);

    useEffect(() => {
        if (isCopied) {
            setTimeout(() => {
                setIsCopied(false);
            }, 1000);
        }
    }, [isCopied]);

    const postLink = baseUrl(`/blog/${postSlug}`);

    return (
        <div className={className}>
            <div className={styles.shareBlock}>
                <a
                    className={styles.shareBlock__link}
                    aria-label="Share on facebook link"
                    href={`https://www.facebook.com/sharer/sharer.php?u=${postLink}`}>
                    <FacebookIcon />
                </a>
                <a
                    className={styles.shareBlock__link}
                    href={`https://twitter.com/intent/tweet?url=${postLink}`}
                    aria-label="Share on twitter link">
                    <TwitterIcon />
                </a>
                <a
                    className={styles.shareBlock__link}
                    href={`https://www.reddit.com/submit?url=${postLink}`}
                    aria-label="Share on reddit link">
                    <RedditIcon />
                </a>
                <CopyToClipboard
                    text={postLink}
                    onCopy={() => setIsCopied(true)}
                    options={{ format: 'text/plain' }}>
                    <button
                        className={classNames(styles.shareBlock__copyBtn, {
                            [styles.copied]: isCopied,
                        })}
                        aria-label="Copy to clipboard button">
                        <LinkIcon />
                    </button>
                </CopyToClipboard>
            </div>
        </div>
    );
};

export { ShareBlock };
